var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.orderGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.orderGetErrors = $event
          }
        }
      }),
      _c("v-data-table", {
        attrs: {
          items: _vm.orderList,
          headers: _vm.headers,
          loading: _vm.orderGetting,
          page: _vm.page,
          "items-per-page": _vm.itemsPerPage,
          "server-items-length": _vm.serverItemsLength,
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          "single-expand": "",
          dense: ""
        },
        on: {
          "update:page": function($event) {
            _vm.page = $event
          },
          "update:itemsPerPage": function($event) {
            _vm.itemsPerPage = $event
          },
          "update:items-per-page": function($event) {
            _vm.itemsPerPage = $event
          },
          "update:sortBy": function($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function($event) {
            _vm.sortDesc = $event
          },
          "update:sort-desc": function($event) {
            _vm.sortDesc = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { "offset-lg": "8", lg: "2", cols: "6" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "purple",
                              dark: "",
                              block: "",
                              dense: "",
                              small: ""
                            },
                            on: {
                              click: function($event) {
                                _vm.exportOrderDialog = true
                              }
                            }
                          },
                          [_c("span", [_vm._v("Export Orders")])]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { lg: "2", cols: "6" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "green",
                              dark: "",
                              block: "",
                              dense: "",
                              small: ""
                            },
                            on: {
                              click: function($event) {
                                _vm.exportItemDialog = true
                              }
                            }
                          },
                          [_c("span", [_vm._v("Export Items")])]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { staticClass: "pb-0", attrs: { cols: "4" } },
                      [
                        _c("v-combobox", {
                          staticClass: "ma-0 pa-0",
                          attrs: {
                            label: "search",
                            "append-icon": "mdi-magnify",
                            clearable: _vm.searches.length,
                            multiple: ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function({ item, parent, selected }) {
                                return [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: "blue-grey darken-3",
                                        dark: "",
                                        "input-value": selected,
                                        label: "",
                                        small: ""
                                      }
                                    },
                                    [
                                      _c("span", [_vm._v(_vm._s(item))]),
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { small: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteItem(item)
                                            }
                                          }
                                        },
                                        [_vm._v("$delete")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.searches,
                            callback: function($$v) {
                              _vm.searches = $$v
                            },
                            expression: "searches"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "1" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            label: "Month",
                            dense: "",
                            items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                            clearable: ""
                          },
                          model: {
                            value: _vm.month,
                            callback: function($$v) {
                              _vm.month = $$v
                            },
                            expression: "month"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "1" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            label: "Year",
                            dense: "",
                            items: [2022, 2021],
                            clearable: ""
                          },
                          model: {
                            value: _vm.year,
                            callback: function($$v) {
                              _vm.year = $$v
                            },
                            expression: "year"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "3" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            dense: "",
                            label: "Revenue Source",
                            items: _vm.revenueSourceIndexList,
                            loading: _vm.revenueSourceIndexGetting,
                            "item-value": "id",
                            "item-text": "code",
                            multiple: "",
                            "small-chips": "",
                            clearable: ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function({ item }) {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "primary--text mr-2" },
                                    [_vm._v(_vm._s(item.code))]
                                  ),
                                  _c(
                                    "small",
                                    { staticClass: "blue-grey--text" },
                                    [_vm._v(_vm._s(item.description))]
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.revenueSources,
                            callback: function($$v) {
                              _vm.revenueSources = $$v
                            },
                            expression: "revenueSources"
                          }
                        })
                      ],
                      1
                    ),
                    _c("v-col", { attrs: { cols: "12" } }, [_c("v-divider")], 1)
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item, expand, isExpanded }) {
              return [
                _c("tr", [
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        item.customer
                          ? _vm.$autoAbbriviate(item.customer.company)
                          : "N/A"
                      )
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.$intToInvoiceNumber(
                          item.invoice ? item.invoice.id : 0
                        )
                      )
                    )
                  ]),
                  _c("td", [_vm._v(_vm._s(item.order_date.dateFormat()))]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(_vm._s((item.total_amount || 0).phpFormat()))
                  ]),
                  _c("td", [
                    _vm._v(_vm._s(item.status ? item.status.name : "N/A"))
                  ]),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(_vm.balance(item).phpFormat()))
                  ]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        item.updated_at.dateFormat({
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      )
                    )
                  ]),
                  _c(
                    "td",
                    [
                      item.order_status_id === "NW"
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                "x-small": "",
                                color: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.changeStatusToDelivered(item.id)
                                }
                              }
                            },
                            [
                              _c("v-icon", [
                                _vm._v("mdi-truck-delivery-outline")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      !item.invoice_count
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                "x-small": "",
                                color: "yellow darken-3"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    name: "orders.edit",
                                    params: { orderId: item.id }
                                  })
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("mdi-pencil")])],
                            1
                          )
                        : _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                "x-small": "",
                                color: "purple darken-3"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    name: "orders.show",
                                    params: { orderId: item.id }
                                  })
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("mdi-eye")])],
                            1
                          ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            "x-small": "",
                            color: "blue-grey darken-3"
                          },
                          on: {
                            click: function($event) {
                              return expand(!isExpanded)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { class: !isExpanded || "is-expanded" },
                            [_vm._v("mdi-chevron-down")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: _vm.headers.length } },
                    [
                      _c("v-simple-table", {
                        attrs: { dense: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [_vm._v("Stock")]),
                                      _c("th", [_vm._v("Quantity")]),
                                      _c("th", [_vm._v("Price")]),
                                      _c("th", [_vm._v("Discount")]),
                                      _c("th", [_vm._v("Amount")])
                                    ])
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(item.details, function(detail) {
                                      return _c("tr", { key: detail.id }, [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              (detail.stock || {})
                                                .description || "N/A"
                                            )
                                          )
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(detail.quantity) +
                                              " " +
                                              _vm._s(detail.unit)
                                          )
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                detail.unit_price || 0
                                              ).phpFormat()
                                            )
                                          )
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              (detail.discount || 0).phpFormat()
                                            )
                                          )
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(_vm.detailAmount(detail))
                                          )
                                        ])
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      }),
      _c(
        "v-dialog",
        {
          attrs: { eager: "", width: "400", persistent: "" },
          model: {
            value: _vm.exportItemDialog,
            callback: function($$v) {
              _vm.exportItemDialog = $$v
            },
            expression: "exportItemDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { color: "purple", dark: "", dense: "", flat: "" } },
                [_c("span", [_vm._v("Export Items")])]
              ),
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pb-0", attrs: { cols: "6" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              dense: "",
                              label: "Customer",
                              items: _vm.customerIndexList,
                              loading: _vm.customerIndexGetting,
                              "item-value": "id",
                              "item-text": "company",
                              clearable: ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "selection",
                                fn: function({ item }) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "primary--text" },
                                      [_vm._v(_vm._s(item.id))]
                                    ),
                                    _c(
                                      "small",
                                      { staticClass: "blue-grey--text ml-2" },
                                      [_vm._v(_vm._s(item.company))]
                                    )
                                  ]
                                }
                              },
                              {
                                key: "item",
                                fn: function({ item }) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "primary--text" },
                                      [_vm._v(_vm._s(item.id))]
                                    ),
                                    _c(
                                      "small",
                                      { staticClass: "blue-grey--text ml-2" },
                                      [_vm._v(_vm._s(item.company))]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.exportItemsFilter.customerId,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.exportItemsFilter,
                                  "customerId",
                                  $$v
                                )
                              },
                              expression: "exportItemsFilter.customerId"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pb-0", attrs: { cols: "6" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              dense: "",
                              label: "Revenue Source",
                              items: _vm.revenueSourceIndexList,
                              loading: _vm.revenueSourceIndexGetting,
                              "item-value": "id",
                              "item-text": "description",
                              multiple: "",
                              "small-chips": "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.exportItemsFilter.revenueSource,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.exportItemsFilter,
                                  "revenueSource",
                                  $$v
                                )
                              },
                              expression: "exportItemsFilter.revenueSource"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 py-0", attrs: { cols: "6" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              dense: "",
                              label: "Month",
                              items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                              clearable: ""
                            },
                            model: {
                              value: _vm.exportItemsFilter.month,
                              callback: function($$v) {
                                _vm.$set(_vm.exportItemsFilter, "month", $$v)
                              },
                              expression: "exportItemsFilter.month"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 py-0", attrs: { cols: "6" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              dense: "",
                              label: "Year",
                              items: [2021, 2022, 2023],
                              clearable: ""
                            },
                            model: {
                              value: _vm.exportItemsFilter.year,
                              callback: function($$v) {
                                _vm.$set(_vm.exportItemsFilter, "year", $$v)
                              },
                              expression: "exportItemsFilter.year"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 py-0", attrs: { cols: "6" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              multiple: "",
                              label: "Status",
                              "small-chips": "",
                              dense: "",
                              items: _vm.orderStatusIndexList,
                              "item-value": "id",
                              clearable: "",
                              "item-text": "name"
                            },
                            model: {
                              value: _vm.exportItemsFilter.status,
                              callback: function($$v) {
                                _vm.$set(_vm.exportItemsFilter, "status", $$v)
                              },
                              expression: "exportItemsFilter.status"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 py-0", attrs: { cols: "6" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              multiple: "",
                              label: "Category",
                              "small-chips": "",
                              dense: "",
                              items: _vm.stockCategoryIndexList,
                              "item-value": "id",
                              clearable: "",
                              "item-text": "name"
                            },
                            model: {
                              value: _vm.exportItemsFilter.stockCategory,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.exportItemsFilter,
                                  "stockCategory",
                                  $$v
                                )
                              },
                              expression: "exportItemsFilter.stockCategory"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-action",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        text: "",
                        color: "green",
                        loading: _vm.orderDetailExportV1Getting
                      },
                      on: { click: _vm.exportDetailV1 }
                    },
                    [_c("span", [_vm._v("Export")])]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "red" },
                      on: {
                        click: function($event) {
                          _vm.exportItemDialog = false
                        }
                      }
                    },
                    [_c("span", [_vm._v("Close")])]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("export-order", {
        attrs: {
          "customer-index-list": _vm.customerIndexList,
          "order-status-index-list": _vm.orderStatusIndexList,
          "revenue-source-index-list": _vm.revenueSourceIndexList
        },
        model: {
          value: _vm.exportOrderDialog,
          callback: function($$v) {
            _vm.exportOrderDialog = $$v
          },
          expression: "exportOrderDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }